module.exports = __webpack_public_path__ + "static/img/login_pic.9063e88b.png";